import React, { useEffect, useState } from 'react';
import { Box, Fade } from '@material-ui/core';
import { useAppContext } from 'contexts/AppContext';
import defaultLocales from 'globals/locales/default';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsLink from 'ui-elements/links/FsLink';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';
import { observer } from 'mobx-react';
import { ButtonWrapperBox, WrapperBox } from './InvoiceHistory.style-elements';
import InvoiceSingleRow from './InvoiceSingleRow';

const InvoiceHistory: React.FC = () => {
  const {
    invoiceHistory: { status, getInvoiceHistoryList, init: initStore },
  } = useAppContext();
  const invoiceList = getInvoiceHistoryList();

  const [showAll, setShowAll] = useState<boolean>(false);
  const invoices = showAll ? invoiceList : invoiceList.slice(0, 5);
  const paidInvoices = invoices.filter(({ isPaid }) => isPaid);
  const unpaidInvoices = invoices.filter(({ isPaid }) => !isPaid);

  const handleToggleList = (event: React.SyntheticEvent) => {
    event.preventDefault();
    setShowAll((oldState) => !oldState);
  };

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in timeout={1900}>
      <FsPaper title={defaultLocales.invoiceHistory}>
        <WrapperBox>
          {!!unpaidInvoices.length && (
            <Box mb={3}>
              {unpaidInvoices.map(({ id, ...props }) => (
                <InvoiceSingleRow key={id} {...{ ...props, id }} />
              ))}
            </Box>
          )}
          {paidInvoices.map(({ id, ...props }) => (
            <InvoiceSingleRow key={id} {...{ ...props, id }} />
          ))}
          <ButtonWrapperBox>
            <FsLink to="#" onClick={handleToggleList} bold>
              {showAll
                ? defaultLocales.showLess
                : defaultLocales.showAllInvoices}
            </FsLink>
          </ButtonWrapperBox>
        </WrapperBox>
      </FsPaper>
    </Fade>
  );
};

export default observer(InvoiceHistory);
